import { get } from './core/fetch';
import _ from 'lodash';

export const getPlanProfileTools = async () => {
	try {
		const params =
			'tidy=true&treenest=true&dumpproperties=pageRoute,pageurl,jcr:title,redirectTarget,hideInNav&ignoreproperties=sling:resourceType,jcr:created';

		const navUrl = `/secure/_content/Adviser/plan-profile/tools.nabfeed.content.2.json?${params}`;
		const siteToolsResult = await get(navUrl);
		return extractSiteLinks(siteToolsResult);
	} catch (err) {
		return undefined;
	}
};

const extractSiteLinks = (data: any) => {
	return _(data.subpages)
		.map(key => {
			return _.flatten(_.toPairs(key))[1];
		})
		.filter((item: any) => !item.hideInNav)
		.map((item: any) => {
			return {
				title: item['jcr:title'],
				url: item.pageurl,
				openInNewTab: true,
			};
		})
		.value();
};
